import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import format from 'string-template';
import { PrimaryButton } from '../../../../../components/Button/ActionButtons';
import texts from '../../texts.json';
import { SessionBannerAlert, SessionBannerTitle } from './style';

const t = texts.brevoSession.banner;

const BrevoSessionBanner = ({ isConfigured, expiresAt, onConfigureClick }) => {
  const variant = isConfigured ? t.configured : t.notConfigured;

  const expiresLabel = (() => {
    if (!isConfigured || !expiresAt) return null;
    const m = moment(expiresAt);
    if (!m.isValid()) return null;
    return format(variant.expires, { date: m.format('MMM D, YYYY') });
  })();

  return (
    <SessionBannerAlert
      severity={isConfigured ? 'success' : 'warning'}
      action={(
        <PrimaryButton
          size="medium"
          $fitToContent
          onClick={onConfigureClick}
        >
          {variant.cta}
        </PrimaryButton>
      )}
    >
      <SessionBannerTitle $hasDescription={Boolean(variant.description)}>
        {variant.title}
        {expiresLabel ? ` — ${expiresLabel}` : ''}
      </SessionBannerTitle>
      {variant.description || null}
    </SessionBannerAlert>
  );
};

BrevoSessionBanner.propTypes = {
  isConfigured: PropTypes.bool,
  expiresAt: PropTypes.string,
  onConfigureClick: PropTypes.func.isRequired,
};

BrevoSessionBanner.defaultProps = {
  isConfigured: false,
  expiresAt: null,
};

export default BrevoSessionBanner;
